import { canManageAi, canManageUsers } from "@/lib/auth/rbac";
import type { SessionRole } from "@/lib/auth/types";

export const reportsCopy = {
  nav: "Отчёты",
  title: "Отчёты",
  description: "Платежи на счёт организации и потреблённые услуги.",
  servicesTitle: "Услуги",
  paymentsTitle: "Платежи",
  servicesEmptyTitle: "Пока нет списаний",
  servicesEmptyDescription: "Чат и индексация появятся здесь.",
  paymentsEmptyTitle: "Пока нет платежей",
  paymentsEmptyDescription:
    "Зачисления и списания со счёта организации появятся здесь.",
  columnWhen: "Когда",
  columnService: "Услуга",
  columnAmount: "Сумма",
  columnWho: "Кто",
  columnKind: "Операция",
  columnComment: "Комментарий",
  serviceChat: "Чат",
  serviceIndex: "Индексация",
  whoSystem: "Система",
  whoMessenger: "Мессенджер",
  whoPlatform: "Платформа",
  kindCredit: "Зачисление",
  kindDebit: "Списание",
} as const;

export function reportsHref(): string {
  return "/reports";
}

export function reportsPaymentsHref(): string {
  return "/reports/payments";
}

export function isReportsNavActive(pathname: string): boolean {
  return pathname === "/reports" || pathname.startsWith("/reports/");
}

export function canAccessReports(roles: SessionRole[]): boolean {
  return canManageAi(roles) || canManageUsers(roles);
}
